export const googleAnalyticsId = "G-9QBTBVDGQX";